import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { siteSpecificData } from '@environments/site-specific-data';
import { IContext } from '@context/models/context';
import { ArrearsCollection } from '../models/arrears-collection';
import { AdminArrearsDataModel } from '../models/admin-arrears-data.model';
import { ArrearsLabels } from '../models/arrears-labels.model';
import { ContextToHttpParamsService } from '@context/services/context-to-params.service';


const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class ArrearsHttpService {

  constructor(
    private readonly http: HttpClient,
    private readonly contextToParamsService: ContextToHttpParamsService
  ) { }

  getArrears(context: IContext): Observable<ArrearsCollection> {
    const httpParams = this.contextToParamsService.getParams(context);
    const arrearsUrl = `${API_URL}arrears`;
    return this.http
      .get<ArrearsCollection>(arrearsUrl, { params: httpParams }).pipe(
        map(arrears => arrears || undefined)
      );
  }

  getAdminArrearsData(): Observable<AdminArrearsDataModel> {
    const url = `${API_URL}adminarrearsdata`;
    return this.http
      .get<AdminArrearsDataModel>(url).pipe(
        map(x => x || undefined)
      );
  }

  getArrearsLabels(): Observable<ArrearsLabels> {
    const url = `${API_URL}arrears/labels`;
    return this.http
      .get<ArrearsLabels>(url).pipe(
        map(x => x || undefined)
      );
  }
}
